/* Product diagnostics v2. No cookies/storage, no ecommerce duplication, analytics consent required. */
(function () {
  'use strict';
  if (!/\/products\//.test(window.location.pathname) || window.__plEngagementV1) return;
  window.__plEngagementV1 = true;
  var sent = {}, visibleSince = {}, last = performance.now(), active = 0;
  var bannerSince = null, pendingChoice = null, scrolled = false, granted = false;
  var actionCount = 0, lastStickyClick = -Infinity;
  var isQA = new URLSearchParams(window.location.search).get('utm_source') === 'qa';
  function allowed() {
    try { return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  function send(name, key, data) {
    if (!granted || !allowed() || sent[key] || typeof window.gtag !== 'function') return;
    sent[key] = true;
    window.gtag('event', name, Object.assign({send_to: 'G-39FESYGHBB', pl_version: '2', pl_is_qa: isQA}, data));
  }
  function action(name, data) { send(name, 'action-'+(++actionCount), data); }
  function isSizeField(field) {
    if(!field) return false;
    var name=field.getAttribute('data-pl-option-name');
    var legend=field.querySelector('legend');
    return name ? name.toLowerCase()==='size' : !!(legend && /^size\b/i.test(legend.textContent.replace(/size guide\s*$/i,'').trim()));
  }
  document.addEventListener('click', function(e) {
    var el=e.target;
    if(!el || !el.closest) return;
    if(el.closest('sticky-add-to-cart button')) {
      lastStickyClick=performance.now();
      action('pl_atc_click',{pl_control:'sticky'});
    } else if(el.closest('.product-information .add-to-cart-button')) {
      // Sticky forwards its click to the main button. Count the original action once.
      if(!e.isTrusted && performance.now()-lastStickyClick<100) return;
      action('pl_atc_click',{pl_control:'main'});
    } else if(el.closest('button[name="checkout"], a[href="/checkout"]')) {
      action('pl_purchase_step',{pl_step:'checkout_click'});
    }
  }, true);
  document.addEventListener('change',function(e){
    var el=e.target, field=el && el.closest && el.closest('.product-information variant-picker fieldset');
    if(isSizeField(field)) action('pl_purchase_step',{pl_step:'size_selected'});
  });
  document.addEventListener('pl:size-guide',function(e){
    if(e.detail && /^(open|close)$/.test(e.detail.action)) action('pl_purchase_step',{pl_step:'size_guide_'+e.detail.action});
  });
  document.addEventListener('cart:update',function(e){
    var data=e.detail && e.detail.data;
    if(data && data.source==='product-form-component' && !data.didError && e.target?.closest?.('.product-information')) action('pl_purchase_step',{pl_step:'add_success'});
  });
  document.addEventListener('cart:error',function(){action('pl_purchase_step',{pl_step:'add_error'});});
  document.addEventListener('dialog:open',function(e){
    if(e.target && e.target.matches && e.target.matches('cart-drawer-component')) action('pl_purchase_step',{pl_step:'cart_open'});
  },true);
  function visible(el) {
    if (!el || !el.getBoundingClientRect) return false;
    var r = el.getBoundingClientRect(), s = getComputedStyle(el);
    return r.width > 0 && r.height > 0 && s.display !== 'none' && s.visibility !== 'hidden' && s.opacity !== '0' &&
      r.bottom > 0 && r.top < window.innerHeight && r.right > 0 && r.left < window.innerWidth;
  }
  function exposed(el) {
    if (!visible(el)) return false;
    var r = el.getBoundingClientRect();
    var h = Math.min(r.bottom, window.innerHeight) - Math.max(r.top, 0);
    if (h < Math.min(r.height, window.innerHeight) * 0.5) return false;
    var x = (Math.max(0,r.left) + Math.min(window.innerWidth,r.right))/2;
    var y = (Math.max(0,r.top) + Math.min(window.innerHeight,r.bottom))/2;
    var top = document.elementFromPoint(x,y);
    return top === el || el.contains(top);
  }
  function banner() { return document.querySelector('#shopify-pc__banner'); }
  function sizeSelector() {
    var fields = document.querySelectorAll ? document.querySelectorAll('.product-information variant-picker fieldset') : [];
    for (var i=0;i<fields.length;i++) {
      if (isSizeField(fields[i])) return fields[i];
    }
    return document.querySelector('.product-information variant-picker select[name="options[Size]"]');
  }
  function resetInterval() { last = performance.now(); visibleSince = {}; scrolled = false; }
  document.addEventListener('visitorConsentCollected', function (e) {
    granted = e.detail && e.detail.analyticsAllowed === true;
    resetInterval();
    pendingChoice = granted && bannerSince !== null ? Math.round((performance.now()-bannerSince)/1000) : null;
  });
  document.addEventListener('visibilitychange', resetInterval);
  window.addEventListener('focus', resetInterval);
  window.addEventListener('blur', resetInterval);
  window.addEventListener('scroll', function () { if (allowed()) scrolled = true; }, {passive:true});
  function tick() {
    var now=performance.now(), delta=Math.min(now-last,1000); last=now;
    var foreground=document.visibilityState==='visible' && document.hasFocus();
    var b=banner(), showing=foreground && visible(b);
    if (showing && bannerSince===null) bannerSince=now;
    var permission=allowed();
    if (permission!==granted) { granted=permission; resetInterval(); delta=0; }
    if (!granted || !foreground) { visibleSince={}; return; }
    if(pendingChoice!==null) {
      send('pl_consent_banner','banner-choice',{pl_banner_action:'analytics_accepted',pl_seconds:pendingChoice});
      pendingChoice=null;
    }
    active+=delta;
    [10,30,60].forEach(function(s){if(active>=s*1000)send('pl_active_time','time-'+s,{pl_seconds:s});});
    if(showing)send('pl_consent_banner','banner-shown',{pl_banner_action:'shown_with_analytics',pl_seconds:0});
    if(scrolled && !showing) {
      var depth=Math.min(100,100*(window.scrollY+window.innerHeight)/document.documentElement.scrollHeight);
      [25,50,75,90].forEach(function(p){if(depth>=p)send('pl_scroll_depth','scroll-'+p,{pl_depth:p});});
    }
    var targets={price:document.querySelector('.product-information product-price'),size_selector:sizeSelector(),
      add_to_cart:document.querySelector('.product-information .add-to-cart-button'),
      sticky_add_to_cart:document.querySelector('sticky-add-to-cart button')};
    Object.keys(targets).forEach(function(k){
      if(!showing && exposed(targets[k])) {
        if(visibleSince[k]===undefined)visibleSince[k]=now;
        if(now-visibleSince[k]>=1000)send('pl_element_view','view-'+k,{pl_element:k});
      } else delete visibleSince[k];
    });
  }
  granted=allowed();
  setInterval(tick,500);
}());
